import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_HEADER_ROW_CLASS_NAME = 'TableHeaderRow';

export const TABLE_HEADER_ROW_CLASS_SLOTS = ['root'] as const;

export type TableHeaderRowClassSlot =
	(typeof TABLE_HEADER_ROW_CLASS_SLOTS)[number];

export interface TableHeaderRowClasses {
	root: string;
	pinnedLeft: string;
	pinnedRight: string;
}

export type TableHeaderRowClassKey = keyof TableHeaderRowClasses;

export const getTableHeaderRowUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_HEADER_ROW_CLASS_NAME, slot);

export const tableHeaderRowClasses = generateUtilityClasses<
	keyof TableHeaderRowClasses
>(TABLE_HEADER_ROW_CLASS_NAME, ['root', 'pinnedLeft', 'pinnedRight']);
export default tableHeaderRowClasses;
